import style from "./style.scss";
import { mergeClasses } from "../helpers";
import { usePopup } from "../popup/context";
import PopupImage from "../popup/image";

const Image = ({
  src,
  small = null,
  alt = null,
  left = false,
  right = false,
  referrerpolicy = null,
  loading = "lazy",
  border = false,
  shadow = false,
  background = null,
  backgroundColor = null,
  maxHeight = null,
  showAlt = false,
  buttonsData = null,
  class: className = null,
  popup: hasPopup = true,
  hoverStyle = null,
  fullWidth = false,
}) => {
  const popup = usePopup();

  const openSlideshow = (e) => {
    e.preventDefault();

    popup.showPopup(
      <PopupImage
        images={[
          {
            lg: src,
            alt: alt,
          },
        ]}
        showAlt={showAlt}
        backgroundColor={backgroundColor}
        referrerpolicy={referrerpolicy}
        loading={loading}
        closePopupHandler={popup.hidePopup}
        buttonsData={buttonsData}
        ariaLabel={alt ? `Image Popup: ${alt}` : "Image Popup"}
      />
    );
  };

  const mergedClass = mergeClasses([
    className,
    style.image,
    right == true ? style.right : left == true ? style.left : null,
  ]);

  return (
    <div class={mergedClass}>
      <div class={style.wrapper}>
        <div
          class={mergeClasses([
            style.item,
            border == true ? style.border : null,
            shadow == true ? style.shadow : null,
            background == true ? style.background : null,
            fullWidth ? style.fullWidth : null,
            hasPopup || hoverStyle ? style.hoverStyle : null,
          ])}
          style={{ backgroundColor: backgroundColor }}
        >
          <img
            src={small ? small : src}
            alt={alt}
            onClick={hasPopup ? (e) => openSlideshow(e) : null}
            referrerpolicy={referrerpolicy}
            loading={loading == "eager" ? "eager" : "lazy"}
            style={{ maxHeight }}
          />
        </div>
      </div>
    </div>
  );
};

export default Image;
